import { api } from '@/api/axiosInstance';
import { ApiResponseType } from '@/api/type/commonTypes';

interface deleteCenterRequest {
  centerId: string;
  remark: string;
}

interface deleteCetnerResponse {
  memberId: string;
}

/** 센터 삭제 */
export const deleteCetner = async ({
  centerId,
  remark,
}: deleteCenterRequest) => {
  const { data } = await api.post<ApiResponseType<deleteCetnerResponse>>(
    `/api/web/admins/partners/centers/${centerId}/delete`,
    {
      remark,
    }
  );

  return data;
};
